var map = {
	"./Icons/aws.png": 35,
	"./Icons/azure.png": 34,
	"./Icons/csharp.png": 28,
	"./Icons/css3.png": 30,
	"./Icons/django.png": 10,
	"./Icons/el.png": 26,
	"./Icons/gh.png": 25,
	"./Icons/html5.png": 29,
	"./Icons/ig.png": 23,
	"./Icons/javascript.png": 31,
	"./Icons/ln.png": 24,
	"./Icons/mysql.png": 33,
	"./Icons/net.png": 17,
	"./Icons/pn.png": 27,
	"./Icons/python.png": 32,
	"./Icons/react.png": 9,
	"./Icons/selenium.png": 36,
	"./clearservices.jpg": 54,
	"./instagram.jpg": 55,
	"./jobsearch.jpg": 56,
	"./jukebox.jpg": 57,
	"./profile.jpg": 22,
	"./yahooscraper.jpg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;